import { render } from "./ClientSpacePurchaseError.vue?vue&type=template&id=2fad2148&scoped=true"
import script from "./ClientSpacePurchaseError.vue?vue&type=script&lang=js"
export * from "./ClientSpacePurchaseError.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=2fad2148&lang=scss&scoped=true"
import "./custom-clientSpacePurchaseError.scss?vue&type=style&index=1&id=2fad2148&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fad2148"]])

export default __exports__